module.exports = __webpack_public_path__ + "static/img/activity01.441bacc6.png";